import { useEffect, useState } from "react";

// Quantity box people can clear and retype. The old inline inputs clamped every
// keystroke to at least 1, so deleting "5" snapped straight back to "1" and
// typing "50" gave "150". This keeps what's being typed as text, passes each
// valid number up as it's typed, and only falls back to the last good quantity
// if the box is left empty. Pass live={false} where every change costs a
// network call (the cart), so it only updates once they finish typing.
export default function QtyInput({ value, onChange, max = 999, live = true, ...inputProps }) {
  const [text, setText] = useState(String(value));
  useEffect(() => { setText(String(value)); }, [value]);

  const handleChange = (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, "");
    setText(digits);
    const n = parseInt(digits, 10);
    if (live && n >= 1) onChange(Math.min(max, n));
  };

  const commit = () => {
    const n = parseInt(text, 10);
    const next = n >= 1 ? Math.min(max, n) : value;
    setText(String(next));
    if (next !== value) onChange(next);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={text}
      onChange={handleChange}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
      onFocus={(e) => e.target.select()}
      {...inputProps}
    />
  );
}
